import MDButton from 'components/MDButton'
import React, { useEffect, useState } from 'react'
import MDModal from 'components/MDModal'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import Editor from './components/editor'

import { Button, Checkbox, FormControlLabel, FormGroup, Stack, TextareaAutosize } from '@mui/material'
import { useAppServices } from 'hook/services'
import { useUserInfo } from 'context/user'
import FormField from 'components/FormField'
import MDInput from 'components/MDInput'
import Multiselect from './components/Multiselect'
const CreateModal = ({ apps, handleRefresh }) => {
  const [openAddProduct, setOpenAddProduct] = useState(false)
  const AppService = useAppServices()
  const [user] = useUserInfo()

  const handlemodal = () => {
    setOpenAddProduct(true)
  }
  useEffect(async () => {}, [])
  function AddProduct({ open, onClose }) {
    const [processing, setProcessing] = useState(false)
    const [permisson_details, setpermisson_details] = useState(null)

    const appOptions = apps
      ?.filter((item) => item?.is_blackBox)
      ?.map((item) => ({
        label: item?.name,
        value: item?.app_id,
      }))

    const handleSubmit = async (e) => {
      e.preventDefault()
      setProcessing(true)
      // const selectedApps = JSON.parse(e.target.apps.value)

      const payload = {
        name: e.target.name?.value,
        key: e.target.key?.value,
        sample_response: e.target.sample_response?.value,
      }

      const { response } = await AppService.app_trigger_model.create({
        payload: payload,
      })

      if (response) {
        setProcessing(false)
        onClose()
        handleRefresh()
      }
    }
    const style = {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 800,
      overflow: 'auto',
      bgcolor: 'background.paper',
      border: '2px  #000',
      boxShadow: 24,
      p: 4,
    }

    return (
      <MDModal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      >
      <MDBox>
        <MDBox component="form" onSubmit={handleSubmit} role="form" sx={style}>
        <MDTypography variant="h5" mb={2}>
          App
        </MDTypography>
        <MDBox>
          <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
          Name
          </MDTypography>
          <MDInput label="Name" name="name" fullWidth />
        </MDBox>

        <MDBox>
          <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
          Modal key
          </MDTypography>
          <MDInput label="Key" name="key" fullWidth />
        </MDBox>
        <MDBox>
          <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
          Sample Response
          </MDTypography>
          <MDBox
          sx={{
            maxHeight: '150px',
            overflowY: 'auto',
            border: '1px solid #ccc',
            borderRadius: '4px',
            padding: '8px',
          }}
          >
          <TextareaAutosize
            type="text"
            name="sample_response"
            minRows={3}
            style={{ width: '100%', resize: 'none' }}
          />
          </MDBox>
        </MDBox>

        <MDBox display="flex" justifyContent="flex-end">
          <MDButton
          variant="gradient"
          color="primary"
          type="button"
          sx={{ mt: 4, mb: 1 }}
          onClick={closeAddProduct}
          >
          close
          </MDButton>
          <MDButton
          variant="gradient"
          color="info"
          type="submit"
          sx={{ mt: 4, mb: 1, ml: 1 }}
          loading={processing}
          disabled={processing}
          >
          Add
          </MDButton>
        </MDBox>
        </MDBox>
      </MDBox>
      </MDModal>
    )
  }
  const closeAddProduct = () => {
    // if (subscription?._id)
    setOpenAddProduct(false)
  }
  return (
    <>
      <MDButton color="white" size="small" variant="contained" onClick={handlemodal}>
        Create
      </MDButton>
      <AddProduct open={openAddProduct} onClose={closeAddProduct} />
    </>
  )
}

export default CreateModal
